import React from 'react';
import { ToastContext, Button, Modal } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

const DeleteModal = ({ widget, show, display, organizationId, triggerRefetch }) => {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const onDelete = React.useCallback(() => {
        widget
            .delete({ organizationId })
            .then(() => {
                triggerRefetch({
                    allow_cache: false
                });
                toast.success(t('ticket.widget.deleteModal.success'));
            })
            .catch(e => {
                console.error(e);
                toast.error(t('ticket.widget.deleteModal.error'));
            })
            .finally(() => {
                display(false);
            });
    });

    return (
        <>
            <Modal
                size="extralarge"
                open={show}
                title={t('ticket.widget.deleteModal.title')}
                onClose={() => display(false)}
                submitButton={<Button primary onClick={onDelete} label={t('ticket.common.action.delete')} />}
                cancelButton={<Button onClick={() => display(false)} label={t('ticket.common.action.back')} />}
            >
                <div>{t('ticket.widget.deleteModal.body')}</div>
            </Modal>
        </>
    );
};

export default DeleteModal;
